import cloudinary from 'cloudinary-core';

export const client = new cloudinary.Cloudinary({
  cloud_name: 'bombas',
  secure: true,
  secure_distribution: 'assets.bombas.com',
  private_cdn: true
});

const originalUrl = client.url.bind(client);
/**
 * Overrides the default Cloudinary URL generation to avoid processing GIFs.
 * This is necessary because Cloudinary transformations on GIFs can lead to images that are larger than their original size.
 */
client.url = function (url, options = {}) {
  const isGif = url && url.toLowerCase().endsWith('.gif');

  // For gifs, just return the original URL without transformations
  if (isGif) {
    return originalUrl(url, { ...options, transformation: [] });
  }

  // For non-gifs, use the original method with all transformations
  return originalUrl(url, options);
};

const gcd = (a, b) => {
  if (b === 0) return a;
  return gcd(b, a % b);
};

/**
 * Calculates the smallest width image 50px or greater which preserves whole number image sizes to maintain aspect ratio.
 *
 * If crops are not defined, then default to 50
 * @param {Object} crop - the height and width for the image
 * @returns {number} - a number representing a width in pixels
 */
export const generateWidth = (crop) => {
  let denom =
    crop.width && crop.height ? crop.width / gcd(crop.width, crop.height) : 50;
  if (denom < 50) denom = 50 + (50 % denom);

  const widthGenerated = Math.ceil(Math.max(50, denom));
  /**
   * @todo:
   * - Need to confirm why max is being used here
   * - For now we are wrapping this to a ceil to ensure that we are always rounding up to the next whole number
   */
  return widthGenerated;
};

export default {};
